<template>
  <div>
    <div
      v-if="!this.isBelowSmallestBreakpoint && !$rttI18n.$isWidget"
      :class="['v-row', 'v-col-12', $rttI18n.isGlsPlSelected && 'pb-0']"
    >
      <h1
        v-if="!$rttI18n.isGlsPlSelected"
        :class="['text-h3', 'pa-0', 'pb', 'mr-4', 'my-4']"
        :style="{ visibility: $rttI18n.isGlsPlSelected ? 'hidden' : null }"
      >
        {{ $t('overview.header') }}
      </h1>
      <h1 v-else class="gls-pl-header font-weight-bold">
        {{ $t('overview.header') }}
      </h1>
    </div>
    <div
      v-if="this.isBelowSmallestBreakpoint && !$rttI18n.$isWidget"
      class="v-row my-0"
    >
      <v-col
        v-if="!$rttI18n.isGlsPlSelected"
        :style="{
          visibility: $rttI18n.isGlsItSelected ? 'hidden' : null
        }"
        class="d-flex text-right align-center font-weight-bold"
      >
        <h2>{{ $t('overview.title') }}</h2>
      </v-col>
      <v-col
        :class="[
          'd-flex',
          !$rttI18n.isGlsPlSelected && 'align-center justify-end',
          $rttI18n.isGlsPlSelected && 'flex-column'
        ]"
        :style="{
          'flex-basis': '50%',
          visibility: $rttI18n.isGlsUsSelected ? 'hidden' : null
        }"
      >
        <template v-if="$rttI18n.isGlsPlSelected">
          <h2 class="gls-pl-header font-weight-bold">
            {{ $t('overview.header') }}
          </h2>
          <h2>
            {{ $rttI18n.tenantSpecificContent('trackingId') }}
            {{ this.trackingData.trackingId }}
          </h2>
        </template>
        <template v-else>
          <h2 class="font-weight-bold">{{ $t('generic.trackingId') }}</h2>
          : {{ this.trackingData.trackingId }}
        </template>
      </v-col>
    </div>
    <v-row class="v-col-12 pa-0 ma-0" data-testId="RealTimeTrackingInProgress">
      <v-col
        v-if="
          this.isBelowSmallestBreakpoint &&
          !configGetter(this.$rttI18n.tenantId, this.themeId).disableOverview
        "
        class="v-col-12 pa-0"
      >
        <OverviewComponent v-bind="$attrs" />
      </v-col>
      <v-col
        :class="this.isBelowSmallestBreakpoint ? 'v-col-12' : 'v-col-6'"
        class="pa-0"
      >
        <MapContainer />
        <FeedbackComponent
          v-if="
            this.$rttI18n.isGlsPlSelected &&
            this.consigneeAddress?.postcode &&
            this.isBelowSmallestBreakpoint
          "
          :postcode="this.consigneeAddress.postcode"
          :ratingData="this.rating"
          :trackingId="this.trackingData.trackingId"
          class="feedback-component"
        />
        <AdComponent
          v-if="
            !this.isBelowSmallestBreakpoint &&
            ((this.trackingData.ad && this.trackingData.ad.length) || 0) < 2 &&
            !configGetter(this.$rttI18n.tenantId, this.themeId).disableOverview
          "
          :adData="this.trackingData.ad"
        />
      </v-col>
      <v-col
        v-if="
          !configGetter(this.$rttI18n.tenantId, this.themeId).disableOverview
        "
        :class="
          this.isBelowSmallestBreakpoint ? 'v-col-12 pa-0' : 'v-col-6 pa-0 pl-4'
        "
      >
        <OverviewComponent
          v-if="!this.isBelowSmallestBreakpoint"
          v-bind="$attrs"
        />
        <FeedbackComponent
          v-if="
            !this.isBelowSmallestBreakpoint &&
            this.$rttI18n.isGlsPlSelected &&
            this.consigneeAddress?.postcode
          "
          :postcode="this.consigneeAddress.postcode"
          :ratingData="this.rating"
          :trackingId="this.trackingData.trackingId"
        />
        <CustomizedDeliveryData
          v-if="
            (this.trackingData.customizedDelivery || this.customizedDelivery) &&
            this.consigneeAddress
          "
        />
        <AdComponent
          v-if="this.isBelowSmallestBreakpoint"
          :adData="this.trackingData.ad"
        />
        <DeliveryAddressComponent />
      </v-col>
    </v-row>
    <AdComponent
      v-if="
        !this.isBelowSmallestBreakpoint &&
        (this.trackingData.ad && this.trackingData.ad.length) >= 2
      "
      :adData="this.trackingData.ad"
    />
  </div>
</template>

<script>
import DeliveryAddressComponent from '../DeliveryAddressComponent';
import MapContainer from '../map/MapContainer';
import OverviewComponent from '../OverviewComponent';
import CustomizedDeliveryData from '../CustomizedDeliveryData';
import AdComponent from '../AdComponent';
import { configGetter } from '@/config/configGetter';
import { mapState } from 'pinia';
import FeedbackComponent from '@/components/feedback/FeedbackComponent.vue';
import { useThemeStore } from '@/stores/theme.js';
import { useResponsiveBreakpointsStore } from '@/stores/responsiveBreakpoints.js';
import { useTrackingDataStore } from '@/stores/trackingData.js';
import { useCustomizedDeliveryStore } from '@/stores/customizedDelivery.js';
import { useRatingStore } from '@/stores/rating.js';

export default {
  inheritAttrs: false,
  name: 'RealTimeTrackingInProgress',
  components: {
    FeedbackComponent,
    CustomizedDeliveryData,
    DeliveryAddressComponent,
    MapContainer,
    OverviewComponent,
    AdComponent
  },
  data() {
    return {
      configGetter
    };
  },
  computed: {
    ...mapState(useTrackingDataStore, {
      trackingData: 'data',
      consigneeAddress: 'consigneeAddress'
    }),
    ...mapState(useThemeStore, ['themeId']),
    ...mapState(useResponsiveBreakpointsStore, ['isBelowSmallestBreakpoint']),
    ...mapState(useCustomizedDeliveryStore, ['customizedDelivery']),
    ...mapState(useRatingStore, ['rating'])
  }
};
</script>

<style scoped>
.feedback-component {
  margin-top: 1em;
  margin-bottom: 1em !important;
}

.gls-pl-header {
  font-size: 1.1em;
}
</style>
